import React from 'react';

function PageNotFound() {
  return (
    <div data-testid="page-not-found">PageNotFound</div>
  );
}

export default PageNotFound;